var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/recent"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 3,
    y: 17,
    rx: 2.5,
    className: "primarytint"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    x: 6,
    y: 2,
    rx: 8.5,
    className: "primarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85 11.762c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l2.789 2.738 3.78-4.623c.15-.2.5-.25.7-.05.2.2.25.5.05.7l-4.13 5.023c-.1.1-.2.15-.35.2h-.05c-.15 0-.25-.05-.35-.15L8.85 11.762zm0 0c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l2.789 2.738 3.78-4.623c.15-.2.5-.25.7-.05.2.2.25.5.05.7l-4.13 5.023c-.1.1-.2.15-.35.2h-.05c-.15 0-.25-.05-.35-.15L8.85 11.762z",
    className: "primarytint"
  }), /*#__PURE__*/React.createElement("path", {
    className: "secondarytint",
    d: "M12.5 3.65a8.85 8.85 0 1 0 0 17.7 8.85 8.85 0 1 0 0-17.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.ec9faf2742fd5c81f1d4bea66b59ded3.svg";
export { ForwardRef as ReactComponent };